import styled from 'styled-components';

export const Text = styled.path`
  color: ${({ theme }) => theme.colors.white};
`;

export const Spiral = styled.path`
  color: ${({ theme }) => theme.colors.logo};
`;
